import React from "react";
import "./WhyUs.css";
import { FaShieldAlt, FaBolt, FaHardHat, FaWarehouse } from "react-icons/fa";

import { useLanguage } from "../../context/LanguageContext";

const WhyUs = () => {
  const { t } = useLanguage();

  return (
    <section className="whyus-section">
      <div className="whyus-container">

        {/* HEADER */}
        <div className="whyus-header">
          <h2>{t.whyUs.headingTitle}</h2>
          <p>{t.whyUs.headingSubtitle}</p>
        </div>

        {/* GRID */}
        <div className="whyus-grid">

          <div className="whyus-card">
            <div className="whyus-icon">
              <FaShieldAlt />
            </div>
            <h3>{t.whyUs.items.safety.title}</h3>
            <p>{t.whyUs.items.safety.description}</p>
          </div>

          <div className="whyus-card">
            <div className="whyus-icon">
              <FaBolt />
            </div>
            <h3>{t.whyUs.items.speed.title}</h3>
            <p>{t.whyUs.items.speed.description}</p>
          </div>

          <div className="whyus-card">
            <div className="whyus-icon">
              <FaHardHat />
            </div>
            <h3>{t.whyUs.items.team.title}</h3>
            <p>{t.whyUs.items.team.description}</p>
          </div>

          <div className="whyus-card">
            <div className="whyus-icon">
              <FaWarehouse />
            </div>
            <h3>{t.whyUs.items.equipment.title}</h3>
            <p>{t.whyUs.items.equipment.description}</p>
          </div>

        </div>

      </div>
    </section>
  );
};

export default WhyUs;
